import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { EnvironmentService } from '../core/environment/environment.service';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { UtilService } from '../shared/utils';
import { AuthService } from '@app/core/auth/auth.service';
import { ValidatedTokenService } from '@app/shared/services/validated-token/validated-token.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../core/environment/environment.service";
import * as i3 from "../shared/utils";
import * as i4 from "../core/auth/auth.service";
import * as i5 from "../shared/services/validated-token/validated-token.service";
var OccurencesService = /** @class */ (function () {
    function OccurencesService(http, environmentService, utils, authService, validatedTokenService) {
        var _this = this;
        this.http = http;
        this.environmentService = environmentService;
        this.utils = utils;
        this.authService = authService;
        this.validatedTokenService = validatedTokenService;
        this.currentGestorDemanda = null;
        this.serviceUrl = '/occurrences';
        this.statusRquest = true;
        this.commentsOccurence = {
            "occurrence": {
                "id": null
            },
            "description": null,
            "userName": null
        };
        this.apiUrl = this.environmentService.envModel.appSettings.apiUrlOccurrence;
        this.apiUrlMenu = this.environmentService.envModel.appSettings.apiUrlMenu;
        this.authSubject = this.authService.getAuthModel();
        this.authSubject.subscribe(function (user) {
            _this.authUser = user;
        });
    }
    Object.defineProperty(OccurencesService.prototype, "jwt", {
        get: function () {
            var headers = new HttpHeaders({ jwt: this.validatedTokenService.jwt });
            return headers;
        },
        enumerable: true,
        configurable: true
    });
    OccurencesService.prototype.getOccurenceTypes = function () {
        return this.http.get(this.apiUrl + this.serviceUrl + '/occurrenceType');
    };
    OccurencesService.prototype.getOccurenceList = function (parameters) {
        if (parameters != undefined) {
            return this.http.get(this.apiUrl + this.serviceUrl, {
                params: new HttpParams()
                    .set('userName', parameters.userName)
                    .set('pageIndex', parameters.pageIndex.toString())
                    .set('pageSize', parameters.pageSize.toString())
                    .set('sortColumn', parameters.sortColumn)
                    .set('sortOrder', parameters.sortOrder)
            });
        }
    };
    OccurencesService.prototype.jsonDataToPortfolios = function (jsonData) {
        var portfolios = [];
        if (jsonData && Array.isArray(jsonData)) {
            jsonData.forEach(function (element) { return portfolios.push(element); });
        }
        return portfolios;
    };
    OccurencesService.prototype.getOccurenceListPost = function (parameters) {
        if (parameters !== undefined) {
            var url = "" + this.apiUrl + this.serviceUrl + "/find-by-filters";
            return this.http.post(url, parameters);
        }
    };
    OccurencesService.prototype.getOcurrenceById = function (occurrenceId) {
        return this.http.get(this.apiUrl + this.serviceUrl + '/' + occurrenceId, { headers: this.jwt });
    };
    OccurencesService.prototype.getCommentsByOccurrenceById = function (occurrenceId) {
        return this.http.get(this.apiUrl + this.serviceUrl + '/' + occurrenceId + '/comments');
    };
    OccurencesService.prototype.getHasCommentsByOcurrenceById = function (occurrenceId) {
        return this.http.get(this.apiUrl + this.serviceUrl + '/' + occurrenceId + '/has-comments');
    };
    OccurencesService.prototype.downloadOcurrenceFileById = function (documentId) {
        return this.http.get("" + this.apiUrl + this.serviceUrl + "/download/" + documentId, { observe: 'response', responseType: 'json', headers: this.jwt });
    };
    OccurencesService.prototype.createOccurence = function (occurence, files) {
        occurence.fundCnpjCpf = occurence.fundCnpjCpf.replace(/[^\d]+/g, '');
        var formData = this.utils.convertPayloadFileToFormData(occurence, 'occurrence', files);
        return this.http.post(this.apiUrl + this.serviceUrl, formData)
            .pipe(catchError(this.handleError));
    };
    OccurencesService.prototype.addCommentsOccurrence = function (payload, idOccurrence) {
        return this.http.post("" + this.apiUrl + this.serviceUrl + "/" + idOccurrence + "/comments", payload, { headers: this.jwt })
            .pipe(catchError(this.handleError));
    };
    OccurencesService.prototype.getOccurrenceComments = function (idOccurrence) {
        return this.http.get("" + this.apiUrl + this.serviceUrl + "/" + idOccurrence + "/comments")
            .pipe(catchError(this.handleError));
    };
    OccurencesService.prototype.manageReadComment = function (occurenceComments) {
        return this.http.post(this.apiUrl + this.serviceUrl + '/comments/read', occurenceComments, { headers: this.jwt })
            .pipe(catchError(this.handleError));
    };
    OccurencesService.prototype.handleError = function (error) {
        this.statusRquest = false;
        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error.message);
        }
        else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error("Backend returned code " + error.status + ", " +
                ("body was: " + error.error));
        }
        // return an observable with a user-facing error message
        return throwError('Erro ao enviar demanda.');
    };
    OccurencesService.cpfCnpjValidator = function (numDoc) {
        numDoc = numDoc.replace(/[^\d]+/g, '');
        if (numDoc.length == 11)
            return this.cpf(numDoc);
        else if (numDoc.length == 14)
            return this.cnpj(numDoc);
        return false;
    };
    OccurencesService.cpf = function (cpf) {
        var numeros, digitos, soma, i, resultado, digitos_iguais;
        digitos_iguais = 1;
        if (cpf.length < 11)
            return false;
        for (i = 0; i < cpf.length - 1; i++)
            if (cpf.charAt(i) != cpf.charAt(i + 1)) {
                digitos_iguais = 0;
                break;
            }
        if (!digitos_iguais) {
            numeros = cpf.substring(0, 9);
            digitos = cpf.substring(9);
            soma = 0;
            for (i = 10; i > 1; i--)
                soma += numeros.charAt(10 - i) * i;
            resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
            if (resultado != digitos.charAt(0))
                return false;
            numeros = cpf.substring(0, 10);
            soma = 0;
            for (i = 11; i > 1; i--)
                soma += numeros.charAt(11 - i) * i;
            resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
            if (resultado != digitos.charAt(1))
                return false;
            return true;
        }
        else
            return false;
    };
    OccurencesService.cnpj = function (cnpj) {
        if (cnpj == '')
            return false;
        if (cnpj.length != 14)
            return false;
        // Elimina CNPJs invalidos conhecidos
        if (cnpj == "00000000000000" ||
            cnpj == "11111111111111" ||
            cnpj == "22222222222222" ||
            cnpj == "33333333333333" ||
            cnpj == "44444444444444" ||
            cnpj == "55555555555555" ||
            cnpj == "66666666666666" ||
            cnpj == "77777777777777" ||
            cnpj == "88888888888888" ||
            cnpj == "99999999999999")
            return false;
        // Valida DVs
        var tamanho = cnpj.length - 2;
        var numeros = cnpj.substring(0, tamanho);
        var digitos = cnpj.substring(tamanho);
        var soma = 0;
        var pos = tamanho - 7;
        for (var i = tamanho; i >= 1; i--) {
            soma += numeros.charAt(tamanho - i) * pos--;
            if (pos < 2)
                pos = 9;
        }
        var resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado != digitos.charAt(0))
            return false;
        tamanho = tamanho + 1;
        numeros = cnpj.substring(0, tamanho);
        soma = 0;
        pos = tamanho - 7;
        for (var i = tamanho; i >= 1; i--) {
            soma += numeros.charAt(tamanho - i) * pos--;
            if (pos < 2)
                pos = 9;
        }
        resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado != digitos.charAt(1))
            return false;
        return true;
    };
    OccurencesService.prototype.downloadDocumentOfCommentById = function (id) {
        return this.http.get("" + this.apiUrl + this.serviceUrl + "/download/" + id, { observe: 'response', responseType: 'json', headers: this.jwt });
    };
    OccurencesService.prototype.getStatus = function () {
        var url = this.apiUrl + "/occurrences/occurrencesStatus";
        return this.http.get(url).pipe(catchError(this.handleError), map(this.jsonDataToComboboxItems));
    };
    OccurencesService.prototype.getPortfolios = function () {
        var url = this.apiUrl + "/occurrences/occurrencePortfolios/name";
        return this.http.get(url);
    };
    OccurencesService.prototype.jsonDataToComboboxItems = function (jsonData) {
        var items = [];
        if (jsonData && Array.isArray(jsonData)) {
            jsonData.forEach(function (element) { return items.push(element); });
        }
        return items;
    };
    OccurencesService.prototype.getPortfoliosBySearch = function (keySearch, typeSearch, pageSize) {
        var apiUrl = this.environmentService.envModel.appSettings.apiUrlMenu;
        var serviceUrl = '/users/portfolio';
        var headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
        pageSize = pageSize ? pageSize : 10;
        return this.http.get("" + apiUrl + serviceUrl, {
            params: {
                search: keySearch,
                typeSearch: typeSearch,
                resultSize: pageSize.toString(),
                manager: this.authUser.gestor
            },
            headers: headers
        });
    };
    OccurencesService.prototype.getCurrentGestorLogged = function () {
        return this.authUser ? this.authUser.gestor : null;
    };
    OccurencesService.ngInjectableDef = i0.defineInjectable({ factory: function OccurencesService_Factory() { return new OccurencesService(i0.inject(i1.HttpClient), i0.inject(i2.EnvironmentService), i0.inject(i3.UtilService), i0.inject(i4.AuthService), i0.inject(i5.ValidatedTokenService)); }, token: OccurencesService, providedIn: "root" });
    return OccurencesService;
}());
export { OccurencesService };
